<template>
  <VueSlideoutPanel
    :value="value"
    :count="1"
    :widths="widths"
    :disableEscClick="false"
    cssClass="no-scroll aside__container"
    :class="!scroll?'non-scroll':''"
    :classes="mainClasses"
    closeHtml=""
    @close="$emit('input', false)">
    <b-container class="aside no-scroll" :class="computedContainerClasses">
      <b-row :class="headerClasses">
        <b-col cols="12" class="aside__header">
          <h2>
            <slot name="header"></slot>
          </h2>

          <slot name="header_action_button"></slot>
          <div class="d-flex">
            <slot name="activation">
            </slot>
            <a @click.prevent="$emit('input', false)" class="btn-close aside__header--close pl-3" style="font-size: 26px" href="#"
               v-if="!disable_close">
              <i class='fa fa-times  aside__close--icon' aria-hidden='true'></i>
            </a>
          </div>

        </b-col>
      </b-row>
      <slot></slot>
    </b-container>
  </VueSlideoutPanel>
</template>

<script>
// docs on https://lyollix.github.io/vue-slideout-panel-demo/
import VueSlideoutPanel from 'vue-slideout-panel'
import {cloneDeep} from "lodash";

export default {
  name: "AppAside",
  components: {
    VueSlideoutPanel
  },
  props: {
    value: {
      default: false,
      type: Boolean
    },
    keep_alive: {
      default: false,
      type: Boolean
    },
    widths: {
      default: () => {
        return ['col-lg-5', 'col-sm-12', '40%']
      }
    },
    disable_close: {
      default: false,
      type: Boolean
    },
    headerClasses: {
      type: Array,
      default: () => {
        return ['mb-3']
      }
    },
    containerClasses: {
      type: Array,
      default: () => {
        return []
      }
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    scroll:{
      type:Boolean,
      default:true
    },
    bodyScroll:{
      type:Boolean,
      default:true
    },
    mainClasses:{
      type:Array,
      default:() =>{
        return ['p-0']
      }
    }

  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    computedContainerClasses() {
      let classes = cloneDeep(this.containerClasses)
      if (this.fullWidth) {
        classes.push('no-max-width', 'w-90')
      }
      return classes;
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          document.body.classList.add('no-scroll')
        } else {
          if(this.bodyScroll) {
            document.body.classList.remove('no-scroll')
          }
        }
      }
    }
  },
  methods: {
    onEscapeKeypress(e) {
      if (!this.disable_close) {
        if (e.keyCode === 27) {
          this.$emit('input', false)
        }
      }
    }
  },
  created() {
    document.addEventListener('keydown', this.onEscapeKeypress);

  },
  destroyed() {
    document.removeEventListener('keydown', this.onEscapeKeypress);
    if(this.bodyScroll){
      document.body.classList.remove('no-scroll')
    }
  }
}
</script>

<style>
.no-scroll {
  overflow: hidden;
}
.non-scroll section.panel.default {
  height: 120%;
  overflow: hidden;
}
.aside__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
